module.exports = __webpack_public_path__ + "img/bancopromerica.0c4ad293.png";